import { useEffect, useState } from 'preact/hooks';
import { api, clp, type DocumentoLista, type Emisor, fmtFecha, fmtRut, type Folio } from '../api';
import { Icono } from '../iconos';

const ESTADOS: Record<string, { txt: string; cl: string }> = {
  borrador: { txt: 'Borrador', cl: '' }, validado: { txt: 'Validado', cl: 'marino' }, firmado: { txt: 'Firmado', cl: 'marino' }, en_cola: { txt: 'En cola de envío', cl: 'marino' }, enviado: { txt: 'Enviado · esperando SII', cl: '' }, fallido: { txt: 'Envío fallido', cl: 'mal' },
  aceptado: { txt: 'Aceptado', cl: 'ok' }, aceptado_reparos: { txt: 'Con reparos', cl: 'reparos' }, rechazado: { txt: 'Rechazado', cl: 'mal' }, anulado: { txt: 'Anulado', cl: 'mal' },
};

export function Listado({ emisor, alNuevo, alAbrir }: { emisor: Emisor; alNuevo: () => void; alAbrir: (id: string) => void }) {
  const [docs, setDocs] = useState<DocumentoLista[] | null>(null);
  const [folios, setFolios] = useState<Folio[]>([]);
  const [tipo, setTipo] = useState('');
  const [q, setQ] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    let vivo = true;
    setDocs(null);
    const p = new URLSearchParams({ emisorId: emisor.id, ...(tipo ? { tipo } : {}), ...(q ? { q } : {}) });
    api<DocumentoLista[]>(`/api/documentos?${p}`).then((d) => vivo && setDocs(d)).catch((e) => setError(e.message));
    api<Folio[]>(`/api/emisores/${emisor.id}/folios`).then((f) => vivo && setFolios(f)).catch(() => {});
    return () => { vivo = false; };
  }, [emisor.id, tipo, q]);

  const bajos = folios.filter((f) => f.disponibles > 0 && f.disponibles < 15).map((f) => f.tipo);
  return (
    <>
      <div class="fila entre">
        <div><h1>Documentos de ventas</h1><div class="sub">{emisor.razon_social}</div></div>
        <button class="boton primario" onClick={alNuevo}><Icono n="mas" tam={18} />Nuevo</button>
      </div>
      <div class="tarjeta fila" style="padding:12px 16px">
        <b>Buscar por:</b>
        <div class="campo" style="flex:1 1 180px;max-width:260px"><label class="oculto" for="f-tipo">Documento</label>
          <select id="f-tipo" value={tipo} onChange={(e) => setTipo((e.target as HTMLSelectElement).value)}>
            <option value="">Documento · todos</option><option value="33">33 Factura electrónica</option><option value="34">34 Factura exenta</option><option value="39">39 Boleta</option><option value="41">41 Boleta exenta</option><option value="43">43 Liquidación factura</option><option value="46">46 Factura de compra</option><option value="56">56 Nota de débito</option><option value="61">61 Nota de crédito</option>
          </select></div>
        <div class="campo" style="flex:1 1 220px;max-width:320px"><label class="oculto" for="f-q">Cliente, RUT o folio</label><input id="f-q" type="search" placeholder="Cliente, RUT o folio" value={q} onChange={(e) => setQ((e.target as HTMLInputElement).value)} /></div>
      </div>
      {error && <div class="error">{error}</div>}
      <div class="tarjeta">
        <div class="tabla-caja">
          <table>
            <thead><tr><th>Documento</th><th>Número</th><th>Cliente</th><th>Fecha</th><th>SII</th><th class="der">Total</th><th></th></tr></thead>
            <tbody>
              {docs === null && <tr><td colSpan={7} class="cargando">Cargando…</td></tr>}
              {docs?.length === 0 && <tr><td colSpan={7} class="cargando">Sin documentos{q || tipo ? ' con ese filtro' : ''}.</td></tr>}
              {docs?.map((d) => {
                const e = ESTADOS[d.estado] ?? { txt: d.estado, cl: '' };
                return (
                  <tr key={d.id} style="cursor:pointer" onClick={() => alAbrir(d.id)}>
                    <td><div style="font-weight:600">({d.tipo_dte}) {d.tipo_nombre}</div><div class="sub">{d.glosa_resumen?.slice(0, 60)}</div></td>
                    <td class="num" style="font-weight:600">{d.folio ?? <span class="sub">—</span>}</td>
                    <td><div>{d.cliente_nombre}</div><div class="sub num">{d.cliente_rut ? fmtRut(d.cliente_rut) : ''}</div></td>
                    <td class="num">{fmtFecha(d.fecha_emision)}</td>
                    <td><span class={`pastilla ${e.cl}`}>{e.txt}</span></td>
                    <td class="der num" style="font-weight:600">{clp(d.monto_total)}</td>
                    <td>{d.folio && <a href={`/api/documentos/${d.id}/pdf`} target="_blank" onClick={(ev) => ev.stopPropagation()} aria-label="Ver PDF" title="Ver PDF" style="color:var(--tinta-3)"><Icono n="pdf" /></a>}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div class="tarjeta folios">
        <span class="sub" style="font-weight:600;margin-right:6px">Folios disponibles</span>
        {folios.length === 0 && <span class="sub">Sin CAF cargados para este emisor.</span>}
        {folios.map((f) => <span key={f.tipo} style="display:inline-flex;align-items:center;gap:7px"><span class="tipo num">{f.tipo}</span><b class="num" style={f.disponibles === 0 ? 'color:#9AA3AF' : f.disponibles < 15 ? 'color:var(--ambar)' : ''}>{f.disponibles}</b></span>)}
        <span style="margin-left:auto;display:inline-flex;align-items:center;gap:10px">
          {bajos.length > 0 && <span class="sub" style="color:var(--ambar);font-weight:600">Quedan pocos folios {bajos.join(', ')}</span>}
          <button class="boton contorno chico" type="button" disabled title="Se habilita con la conexión de folios al SII">Solicitar folios</button>
        </span>
      </div>
    </>
  );
}
